/**
 * Get a unique key for a constructor or method based on name and parameter signature.
 * Ensures overloaded items (same name, different parameters) get unique keys.
 *
 * @returns Unique key string in format: "name(type1,type2)" or "name_index" if no parameters
 */
export const getUniqueKey = (item: { name: string; parameters: { type: string }[] }, index?: number): string => {
  const paramSignature = item.parameters.map((p) => p.type).join(',')
  if (paramSignature) {
    return `${item.name}(${paramSignature})`
  }
  return index !== undefined ? `${item.name}_${index}` : item.name
}
